import TicketSubmit from '../components/ticket-submit.tsx'
import {CHATBOT_SOURCES} from '../types'
import {useChatbotStore} from '../store/chatbotStore'
import i18next from 'i18next'

export const mb4FlowSteps = () => [
    {
        id: 'MB4',
        message: i18next.t('chatbot:commons:share_airbnb_id'),
        trigger: () => {
            useChatbotStore.getState().addStepToHistory({
                id: 'MB4',
                source: CHATBOT_SOURCES.CHATBOT,
                text: 'Please share the airbnb ID or any information to help us identify the listing in our system.'
            })
            return 'MB4.1'
        }
    },
    {
        id: 'MB4_specific',
        message: i18next.t('chatbot:mb4:mb4_specific'),
        trigger: () => {
            useChatbotStore.getState().addStepToHistory({
                id: 'MB4_specific',
                source: CHATBOT_SOURCES.CHATBOT,
                text: 'Please write your question below. Make sure to be very detailed so we can support faster.'
            })
            return 'MB4.1'
        }
    },
    {
        id: 'MB4.1',
        user: true,
        validator: (value: string) => (value === '' ? i18next.t('chatbot:commons:enter_message') : true),
        trigger: ({value}: {value: string}) => {
            useChatbotStore.getState().addStepToHistory({
                id: 'MB4.1',
                source: CHATBOT_SOURCES.USER,
                text: value
            })
            return 'MB4_ticket'
        }
    },
    {
        id: 'MB4_ticket',
        component: <TicketSubmit reason="generic_ticket" />,
        trigger: () => {
            useChatbotStore.getState().addStepToHistory({
                id: 'MB4_ticket',
                source: CHATBOT_SOURCES.CHATBOT,
                text: '[Ticket submitted]'
            })
            return 'send_log'
        },
        asMessage: true
    }
]
